import { JSONInterface } from 'Interfaces/JsonInterface';
import { getRequestConfig } from 'api';
import * as adminApi from 'api/adminApi';
import { getLocalization } from 'global/global';
import { AdminUserDraft } from 'Interfaces/Admin';
import { deactivateAdminUsers, mergeAdminUsers, upsertAdminUser } from 'reducers/admin/users';
import { pendingToast } from './adminToast';
import { loadUserStats } from './adminBootstrapActions';

export const importUsers = (file: File, user) => {
  return new Promise((resolve, reject) => {
    const headers = getRequestConfig();
    const data = { ...headers };

    const formData = new FormData();
    formData.append('file', file);
    formData.append('user', JSON.stringify(user));
    delete data.headers['Content-Type'];

    data['method'] = 'POST';
    data['body'] = formData;

    fetch('/json/admin/import/users', data).then(res => res.json()).then(json => {
      resolve(json);
    }).catch(e => {
      reject(e);
    });
  });
};

export const getAccountUserStats = () => {
  return new Promise<JSONInterface>((resolve, reject) => {
    const headers = getRequestConfig();
    const data = { ...headers };

    fetch('/json/admin/getUserStats', data).then(res => res.json()).then(json => {
      resolve(json);
    }).catch(e => {
      reject(e);
    });
  });
};

/**
 *  The admin tool's own user operations, replacing sync/UserSync.js and
 *  sync/UserCollectionSync.js.
 */

export const reloadAdminUsers = () => {
  return async (dispatch): Promise<void> => {
    const notify = pendingToast(getLocalization('reloadingUsers'));
    try {
      dispatch(mergeAdminUsers(await adminApi.fetchUsers()));
      notify.succeed(getLocalization('usersReloaded'));
    } catch (e) {
      console.log(e);
      notify.fail(getLocalization('errorReloadingUsers'));
    }
  };
};

export const saveAdminUser = (user: AdminUserDraft) => {
  return async (dispatch): Promise<boolean> => {
    const notify = pendingToast(getLocalization('savingUser'));
    try {
      const response = await adminApi.saveUser(user);
      if (response.status !== 'OK' || !response.user) {
        notify.fail(
          response.errorCode ? getLocalization(`error${response.errorCode}`) : getLocalization('userSaved'),
        );
        return false;
      }
      notify.succeed(getLocalization(response.message || 'userSaved'));
      dispatch(upsertAdminUser(response.user));
      // Seat counters can move in either direction here, so re-read them.
      void dispatch(loadUserStats());
      return true;
    } catch (e) {
      console.log(e);
      notify.fail(getLocalization('errorSavingUser'));
      return false;
    }
  };
};

export const deleteAdminUsers = (ids: number[]) => {
  return async (dispatch): Promise<boolean> => {
    const notify = pendingToast(`${getLocalization('deleting')} ${ids.length}`);
    try {
      const response = await adminApi.deleteUsers(ids);
      if (response.status === 'FAIL') {
        notify.fail(getLocalization('deletefail'));
        return false;
      }
      dispatch(deactivateAdminUsers(response.ids || []));
      void dispatch(loadUserStats());
      if (response.status === 'PARTIAL') {
        notify.fail(getLocalization('deletePartial'));
      } else {
        notify.succeed(getLocalization('deleteSuccess'));
      }
      return true;
    } catch (e) {
      console.log(e);
      notify.fail(getLocalization('deletefail'));
      return false;
    }
  };
};
